
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Link } from "react-router-dom";
import { SEO } from "@/components/SEO";
import { Helmet } from "react-helmet-async";
import { Link as LinkIcon } from "lucide-react";

export default function Sitemap() {
  const siteStructure = [
    {
      section: "Main Pages",
      links: [
        { title: "Home", url: "/" },
        { title: "Secondary Glazing Services", url: "/secondary-glazing" },
        { title: "Secondary Glazing Benefits", url: "/secondary-glazing-benefits" },
        { title: "Request a Quote", url: "/get-quote" },
        { title: "Blog", url: "/blog-secondary-glazing" },
      ]
    },
    {
      section: "Secondary Glazing Benefits",
      links: [
        { title: "Noise Reduction", url: "/noise-reduction-secondary-glazing" },
        { title: "Thermal Insulation", url: "/thermal-insulation-secondary-glazing" },
        { title: "Heritage Preservation", url: "/heritage-preservation-secondary-glazing" },
        { title: "Secondary Glazing Costs", url: "/secondary-glazing-cost" },
      ]
    },
    {
      section: "Secondary Glazing Types",
      links: [
        { title: "Fixed Units", url: "/fixed-units-glazing" },
        { title: "Sliding Units", url: "/sliding-units-glazing" },
        { title: "Hinged Units", url: "/hinged-units-glazing" },
        { title: "Lift Out Units", url: "/lift-out-units-glazing" },
        { title: "Vertical Sliding Units", url: "/vertical-sliding-units-glazing" },
        { title: "Horizontal Sliding Units", url: "/horizontal-sliding-units-glazing" },
      ]
    },
    {
      section: "Blog Articles",
      links: [
        { title: "Noise Reduction Guide", url: "/blog/noise-reduction-guide" },
        { title: "Thermal Insulation Benefits", url: "/blog/thermal-insulation-benefits" },
        { title: "Listed Building Guide", url: "/blog/listed-building-guide" },
        { title: "Secondary vs Double Glazing", url: "/blog/secondary-vs-double-glazing" },
        { title: "DIY Measurement Guide", url: "/blog/diy-measurement-guide" },
        { title: "Energy Savings Calculator", url: "/blog/energy-savings-calculator" },
        { title: "Condensation Prevention Guide", url: "/blog/condensation-prevention-guide" },
        { title: "Bay Window Solutions", url: "/blog/bay-window-solutions" },
        { title: "Seasonal Maintenance Guide", url: "/blog/seasonal-maintenance-guide" },
      ]
    },
    {
      section: "Gallery & Resources",
      links: [
        { title: "Secondary Glazing Gallery", url: "/secondary-glazing-images" },
        { title: "Case Studies", url: "/case-studies" },
        { title: "FAQ", url: "/faq" },
        { title: "Free Resources", url: "/free-resources" },
      ]
    },
    {
      section: "Areas We Serve",
      links: [
        { title: "Chelsea", url: "/chelsea-secondary-glazing" },
        { title: "Kensington", url: "/kensington-secondary-glazing" },
        { title: "Knightsbridge", url: "/knightsbridge-secondary-glazing" },
        { title: "Mayfair", url: "/mayfair-secondary-glazing" },
        { title: "Hampstead", url: "/hampstead-secondary-glazing" },
        { title: "Richmond", url: "/richmond-secondary-glazing" },
        { title: "View All Locations", url: "/locations" },
      ]
    },
    {
      section: "Legal Information",
      links: [
        { title: "Privacy Policy", url: "/privacy-policy" },
        { title: "Terms & Conditions", url: "/terms-conditions" },
        { title: "Cookie Policy", url: "/cookie-policy" },
        { title: "Disclaimer", url: "/disclaimer" },
        { title: "Accessibility Statement", url: "/accessibility-statement" },
      ]
    },
    {
      section: "Utility Pages",
      links: [
        { title: "FAQ", url: "/faq" },
        { title: "Sitemap", url: "/sitemap" },
        { title: "XML Sitemap", url: "/sitemap-xml", icon: LinkIcon }
      ]
    },
  ];

  return (
    <main className="flex min-h-screen flex-col">
      <Helmet>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <SEO 
        title="Sitemap" 
        description="Navigate all pages on the London Secondary Glazing website with our comprehensive sitemap." 
        canonical="https://www.londonsecondaryglazing.co.uk/sitemap"
      />
      <Navbar />
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold mb-8 text-primary">Sitemap</h1>
          <p className="text-lg mb-8">Use our sitemap to navigate to any page on the London Secondary Glazing website.</p>
          
          <div className="space-y-12">
            {siteStructure.map((section, index) => (
              <div key={index} className="border-b pb-8 last:border-b-0">
                <h2 className="text-2xl font-semibold mb-4 text-primary">{section.section}</h2>
                <ul className="grid grid-cols-1 md:grid-cols-2 gap-2">
                  {section.links.map((link, linkIndex) => (
                    <li key={linkIndex} className="flex items-center">
                      <Link 
                        to={link.url} 
                        className="text-blue-600 hover:text-blue-800 hover:underline flex items-center"
                      >
                        {link.title}
                        {link.icon && <link.icon className="ml-2 h-4 w-4" />}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </main>
  );
}
